import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { VersionCheckService } from "common/version-check/version-check.service";

export const versionCheckOnLogin: CanActivateFn = async () => {
	const versionCheck = inject(VersionCheckService);

	if (await versionCheck.needsReload()) {
		// user is already logged out (or going to login), safe to hard reload
		location.reload();
		return false; // navigation becomes irrelevant
	}

	return true;
};